import React from 'react';
import Banner1 from "../../assets/images/bannerHero.png"
import { Link } from 'react-router-dom';
const Hero = () => {
  return (
    <div className="relative h-[75vh] w-full overflow-hidden">
      <img
        src={Banner1}
        alt="Motorcycle rider in garage"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-black/20" />
      <div className="absolute bottom-20 left-10 md:left-20 max-w-lg z-10">
        <h2 className="text-sm uppercase tracking-wider mb-4 text-white">2025</h2>
        <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white">Koleksioni i moto</h1>
        <Link to="products" className="px-6 py-3 bg-transparent border border-white text-white hover:bg-white hover:text-black transition-colors uppercase text-sm tracking-wide">
          Eksploro më shumë
        </Link>
      </div>
      <div className="absolute left-0 right-0 bottom-10 md:bottom-20 flex justify-center z-10">
        <div className="flex space-x-2">
          <button className="w-3 h-3 rounded-full bg-gray-400"></button>
          <button className="w-3 h-3 rounded-full bg-white"></button>
          <button className="w-3 h-3 rounded-full bg-gray-400"></button>
        </div>
      </div>
      <div className="absolute left-5 top-1/2 -translate-y-1/2 z-10">
        <button className="text-white p-2">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
      <div className="absolute right-5 top-1/2 -translate-y-1/2 z-10">
        <button className="text-white p-2">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
    </div>
  );
};
export default Hero;
